import { IconAlertTriangle } from "@tabler/icons-react";
import { Alert, Group, Stack, Text } from "@/components/ui";
import type { ReglaError } from "@/lib/types";

/** Alerta roja con la lista de reglas RN1-RN10 rechazadas. */
export function ReglasRechazadasAlert({ errores }: { errores: ReglaError[] }) {
  if (errores.length === 0) return null;
  return (
    <Alert variant="error" icon={<IconAlertTriangle size={18} />} title="Reglas rechazadas">
      <Stack gap="xs" className="mt-1.5">
        {errores.map((e) => (
          <Group key={e.codigo} align="flex-start" gap="xs" wrap="nowrap">
            <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[10px] text-peligro-600">
              {e.codigo}
            </code>
            <Text size="sm">{e.mensaje}</Text>
          </Group>
        ))}
      </Stack>
    </Alert>
  );
}
